import React, { useState, useEffect } from 'react';
import content from '../data/content';

const API_URL = 'https://dev.sijelly.com/api';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', nachricht: '', honeypot: '' });
  const [sent, setSent] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.honeypot) return;

    const response = await fetch(`${API_URL}/send-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });

    if (response.ok) {
      setSent(true);
      setForm({ name: '', email: '', nachricht: '', honeypot: '' });
      setTimeout(() => setSent(false), 5000);
    }
  };

  const co = content.company;

  return (
    <section className="section contact-section" style={{ paddingTop: 120 }}>
      <div className="container">
        <div className="section-header">
          <span className="section-label">Kontakt</span>
          <h2 className="section-title">Sprechen Sie uns an</h2>
          <p className="section-subtitle">
            Wir freuen uns auf Ihre Anfrage. Kontaktieren Sie uns direkt oder über das Formular.
          </p>
        </div>
        <div className="contact-grid">
          <div className="contact-info">
            <h3>Sijelly IT GmbH</h3>
            <p>
              Als erfahrene IT-Beratung unterstützen wir Sie bei Ihren Projekten —
              von Consulting über Testmanagement bis Programm Management.
            </p>
            <div className="contact-details">
              <div className="contact-detail">
                <div className="contact-detail-icon">📍</div>
                <div className="contact-detail-text">
                  <span>Adresse</span>
                  <a href={co.mapsUrl} target="_blank" rel="noopener noreferrer">
                    {co.address}, {co.city}
                  </a>
                </div>
              </div>
              <div className="contact-detail">
                <div className="contact-detail-icon">📞</div>
                <div className="contact-detail-text">
                  <span>Telefon</span>
                  <a href={`tel:${co.phone}`}>{co.phone}</a>
                </div>
              </div>
              <div className="contact-detail">
                <div className="contact-detail-icon">✉️</div>
                <div className="contact-detail-text">
                  <span>E-Mail</span>
                  <a href={`mailto:${co.email}`}>{co.email}</a>
                </div>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                id="name"
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Ihr Name"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">E-Mail</label>
              <input
                id="email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="ihre@email.de"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="nachricht">Nachricht</label>
              <textarea
                id="nachricht"
                name="nachricht"
                value={form.nachricht}
                onChange={handleChange}
                placeholder="Wie können wir Ihnen helfen?"
                required
              />
            </div>
            <div style={{ display: 'none' }}>
              <input type="text" name="honeypot" value={form.honeypot} onChange={handleChange} />
            </div>
            {sent && <div className="success-msg">Nachricht erfolgreich gesendet!</div>}
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!form.name || !form.email || !form.nachricht}
            >
              Nachricht senden
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
